import { FC } from 'react';
// Mui
import { Alert } from '@mui/material';
// i18next
import { useTranslation } from 'react-i18next';

const OrdersAlert:FC = () => {
  const { t } = useTranslation();

  return (
    <Alert
      sx={{ mb: 4 }}
      color="info"
    >{t('pages.orders.noSubscriptionData')}</Alert>
  )
}

export default OrdersAlert;
